const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 13/12/16.
 */
const React = require('react');

const {formatText} = require('core/i18n').i18n;
const { Accordion } = require('commonsComponents/accordion');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { InputSafe } = require('commonsComponents/inputSafe');

const mockHelper = require('../../../utilities/mockDataHelper');

class WorkersData extends React.Component {
    constructor(props) {
        super(props);
        let initialState;
        if (this.props.values) {
            initialState = this.props.values;
        } else {
            initialState = {
                seniorityProfession: '',
                annualNetIncome: '',
                justifiedAmount: '',
                periodicity: '',
                typeTaxation: ''
            };
        }
        this.state = initialState;
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnChangePeriodicity = this.handleOnChangePeriodicity.bind(this);
        this.handleOnChangeTypeTaxation = this.handleOnChangeTypeTaxation.bind(this);
    }


    handleOnBlur(event) {
        this.setState({[event.target.name] : event.target.value});
    }

    handleOnChangePeriodicity(event) {
        this.setState({periodicity : event.value});
    }

    handleOnChangeTypeTaxation(event) {
        this.setState({typeTaxation: event.value});
    }

    render() {
        this.props.dataReceiver(this.state);
        return (
            <Accordion customClassName="laboral-data__accordion" isExpanded={true}>
                <AccordionHeader
                    name="AccordionHeader"
                    isRightArrowPosition={true}>
                    <h4 className="laboral-data__subtitle">{formatText('contractsView-checkingAccountLaboralDataWorkersDataTitle')}</h4>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div>
                        <div>
                            <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                                <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataSeniorityProfessionTitle')}</div>
                                <InputSafe
                                    label={null}
                                    name="seniorityProfession"
                                    onBlur={this.handleOnBlur}
                                    onChange={null}
                                    referenceName="seniorityProfession"
                                    type="text"
                                    value={this.state.seniorityProfession}
                                />
                            </div>
                            <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                                <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataAnnualNetIncomeTitle')}</div>
                                <InputSafe
                                    label={null}
                                    name="annualNetIncome"
                                    onBlur={this.handleOnBlur}
                                    onChange={null}
                                    referenceName="annualNetIncome"
                                    type="text"
                                    value={this.state.annualNetIncome}
                                />
                            </div>
                            <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                                <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataAmountJustifiedTitle')}</div>
                                <InputSafe
                                    label={null}
                                    name="justifiedAmount"
                                    onBlur={this.handleOnBlur}
                                    onChange={null}
                                    referenceName="justifiedAmount"
                                    type="text"
                                    value={this.state.justifiedAmount}
                                />
                            </div>
                        </div>
                        <div>
                            <div className="laboral-data__workers-data--second-row laboral-data__form-element">
                                <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataPeriodicityTitle')}</div>
                                <OKSelect
                                    placeholder="Selecciona"
                                    searchable={true}
                                    options={mockHelper.mockPeriodicity()}
                                    onChange={this.handleOnChangePeriodicity}
                                    value={this.state.periodicity}
                                />
                            </div>
                            <div className="laboral-data__workers-data--second-row laboral-data__form-element">
                                <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataTypeTaxationTitle')}</div>
                                <OKSelect
                                    placeholder="Selecciona"
                                    searchable={true}
                                    options={mockHelper.mockTypeTaxation()}
                                    onChange={this.handleOnChangeTypeTaxation}
                                    value={this.state.typeTaxation}
                                />
                            </div>
                        </div>
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }
}

WorkersData.propTypes = {
    values: PropTypes.object,
    dataReceiver: PropTypes.func
};

module.exports = WorkersData;